import React, { useState, useRef } from "react";
import ContainerCard from "./containerCard";
import { Chevron } from "@speedoc/design-assets/build/icons/index";
import { Button } from "@speedoc/design-assets";
import { Link } from "react-router-dom";

export default function DropdownDetails({ content }) {
  const [open, setOpen] = useState(undefined);
  const component = useRef({});

  const toggleCard = index => setOpen(index === open ? undefined : index);
  const cardHeight = (index, isList) => {
    const height = component.current.children[index].querySelector(".cardContent .text").offsetHeight;
    return isList ? parseInt(height, 10) + 16 : height;
  };

  return (
    <div className="dropdownDetails" ref={component}>
      {content.list.map((card, index) => {
        return (
          <div key={index} onClick={() => toggleCard(index)}>
            <ContainerCard key={index}>
              <div className={`cardTitle ${open === index ? "open" : ""}`}>
                <Chevron />
                <p className={`title ${open === index ? "open" : ""}`}>{card.title}</p>
              </div>
              <div
                style={{
                  height: open !== undefined && open === index ? cardHeight(index, card.isList) : null
                }}
                className={`cardContent ${open === index ? "open" : ""}`}>
                <div className={`text ${open === index ? "open" : ""}`}>
                  {card.entries.map((entry, i) => (
                    <div key={i} className={`entry ${card.isList ? "margin" : ""}`}>
                      {card.isList && <span className="li" />}
                      <span> {entry.text}</span>
                    </div>
                  ))}
                  {card.button && (
                    <Link to={card.button.path || "/"}>
                      <Button className={`${content.buttonIsPrimary ? "primary" : "secondary"} sm`}>
                        <span>{card.button.text}</span>
                      </Button>
                    </Link>
                  )}
                </div>
              </div>
            </ContainerCard>
          </div>
        );
      })}
    </div>
  );
}
